import { Pipe, PipeTransform } from '@angular/core';
import { CounterDto, MeterType } from '@lib-ui/client';
import { getCounterDescription } from '@lib-ui/lib/functions/counter-description';

@Pipe({
  name: 'counterDescription',
  standalone: true,
})
export class CounterDescriptionPipe implements PipeTransform {

  transform(counter: CounterDto, meterType?: MeterType): string {
    return getCounterDescription(meterType ?? null, counter);
  }

}
